// src/components/InfluencerForm.js

import React, { useState } from 'react';
import {
  Box, Button, FormControl, FormLabel, Input, VStack, Heading, useToast, Container,
} from '@chakra-ui/react';
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const InfluencerForm = () => {
  const [formData, setFormData] = useState({
    member_id: '',
    influencer_name: '',
    social_media_link: '',
  });
  const [isLoading, setIsLoading] =useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/influencers/create`, formData);
      toast({
        title: 'Success!',
        description: "Influencer profile has been submitted.",
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      setFormData({ member_id: '', influencer_name: '', social_media_link: '' });
    } catch (error) {
      toast({
        title: 'Submission Failed.',
        description: error.response?.data?.message || 'An error occurred.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxW="container.md" py={12}>
      <Box p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
        <Heading mb={6} textAlign="center">Add Influencer Profile</Heading>
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel htmlFor="member_id">Your Member ID</FormLabel>
              <Input id="member_id" name="member_id" value={formData.member_id} onChange={handleChange} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel htmlFor="influencer_name">Influencer's Full Name</FormLabel>
              <Input id="influencer_name" name="influencer_name" value={formData.influencer_name} onChange={handleChange} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel htmlFor="social_media_link">Social Media Page Link</FormLabel>
              <Input id="social_media_link" name="social_media_link" type="url" placeholder="https://www.instagram.com/username" value={formData.social_media_link} onChange={handleChange} />
            </FormControl>
            <Button type="submit" colorScheme="brand" width="full" mt={4} isLoading={isLoading}>
              Submit Profile
            </Button>
          </VStack>
        </form>
      </Box>
    </Container>
  );
};

export default InfluencerForm;